/*!
 * PES Supply — Competitive Features v2
 * Rewritten to parse data directly from DOM instead of async fetches
 * Implements: $/W pricing, New badges, Price Match badge, Best Value badge, EOL banner
 * Brand green: #11B67B
 */(function(){"use strict";

var BRAND_GREEN = "#11B67B";
var NEW_PRODUCT_DAYS = 30;

function injectStyles() {
  if (document.getElementById("pes-pcf-v2-styles")) return;
  var css = document.createElement("style");
  css.id = "pes-pcf-v2-styles";
  css.textContent = [
    ".pes-badge-row{display:flex;flex-wrap:wrap;gap:6px;margin:6px 0;padding:0 4px;}",
    ".pes-badge{display:inline-flex;align-items:center;gap:4px;font-size:11px;",
    "font-weight:700;letter-spacing:.3px;text-transform:uppercase;padding:3px 8px;",
    "border-radius:999px;line-height:1.3;white-space:nowrap;font-family:inherit;}",
    ".pes-badge--new{background:" + BRAND_GREEN + ";color:#fff;}",
    ".pes-badge--best-value{background:#0a1628;color:#fff;border:1px solid " + BRAND_GREEN + ";}",
    ".pes-badge--price-match{background:#fff;color:#0a1628;border:1.5px solid " + BRAND_GREEN + ";}",
    ".pes-badge--pallet{background:#f4f6f5;color:#0a1628;border:1px solid #d7dedb;}",
    ".pes-card-wpd{font-size:12px;font-weight:700;color:" + BRAND_GREEN + ";",
    "margin-top:2px;display:block;padding:0 4px;}",
    ".pes-card-wpd .wpd-label{color:#6b7c75;font-weight:500;font-size:11px;}",
    ".pes-card-pallet{font-size:12px;font-weight:600;color:#3a4a44;",
    "margin-top:2px;display:block;padding:0 4px;}",
    ".pes-card-pallet strong{color:" + BRAND_GREEN + ";font-weight:800;}",
    ".pes-price-match-badge{display:flex;align-items:flex-start;gap:10px;",
    "background:#f4fbf8;border:1.5px solid " + BRAND_GREEN + ";border-radius:10px;",
    "padding:12px 14px;margin:14px 0;font-size:13.5px;line-height:1.45;color:#0a1628;}",
    ".pes-price-match-badge svg{flex:none;width:20px;height:20px;color:" + BRAND_GREEN + ";margin-top:1px;}",
    ".pes-price-match-badge a{color:" + BRAND_GREEN + ";font-weight:700;text-decoration:underline;}",
    ".pes-eol-banner{display:flex;align-items:flex-start;gap:10px;",
    "background:#fff3cd;border:1.5px solid #ffc107;border-radius:10px;",
    "padding:12px 14px;margin:14px 0;font-size:13.5px;line-height:1.45;color:#664d03;}",
    ".pes-eol-banner svg{flex:none;width:20px;height:20px;color:#ffc107;margin-top:1px;}",
    ".pes-eol-banner a{color:#664d03;font-weight:700;text-decoration:underline;}",
    ".pes-pallet-block{background:#f4f6f5;border:1px solid #d7dedb;border-radius:10px;",
    "padding:14px 16px;margin:14px 0;}",
    ".pes-pallet-block .ppb-title{font-size:14px;font-weight:800;color:#0a1628;margin-bottom:8px;}",
    ".pes-pallet-block .ppb-line{display:flex;justify-content:space-between;",
    "font-size:13px;padding:3px 0;color:#3a4a44;}",
    ".pes-pallet-block .ppb-line strong{color:" + BRAND_GREEN + ";font-weight:700;}"
  ].join("");
  document.head.appendChild(css);
}

// Extract wattage from product title or card text
function extractWattage(text) {
  if (!text) return null;
  // Match patterns like "430W", "430 Watt", "590 W", "710watt"
  var m = text.match(/(\d{2,4})\s*[wW](?:att)?\b/);
  if (m) return parseInt(m[1], 10);
  // Match "430Wp"
  m = text.match(/(\d{2,4})\s*[wW]p\b/);
  if (m) return parseInt(m[1], 10);
  return null;
}

// Extract price from card's price element
function extractPrice(card) {
  // Try multiple price selectors used by Dawn/Shopify themes
  var priceEl = card.querySelector('.price__regular .price-item, .price-item--regular, .price__current .price-item, .price-item, [data-price]');
  if (priceEl) {
    var text = priceEl.textContent || priceEl.getAttribute('data-price') || '';
    if (text) {
      // Handle data-price attribute (cents)
      if (/^\d+$/.test(text.trim())) {
        return parseFloat(text) / 100;
      }
      var m = text.match(/\$?([\d,]+\.?\d*)/);
      if (m) return parseFloat(m[1].replace(/,/g, ''));
    }
  }
  // Fallback: any element with $ in the card
  var allText = card.textContent;
  var priceMatches = allText.match(/\$(\d{1,3}(?:,\d{3})*(?:\.\d{2})?)/);
  if (priceMatches) return parseFloat(priceMatches[1].replace(/,/g, ''));
  return null;
}

// Extract product handle from card
function getCardHandle(card) {
  var link = card.querySelector('a[href*="/products/"]');
  if (!link) return null;
  var href = link.getAttribute('href');
  var m = href.match(/\/products\/([a-z0-9\-]+)/i);
  return m ? m[1] : null;
}

// Get product title from card
function getCardTitle(card) {
  var heading = card.querySelector('.card__heading, .card-information, .card__info');
  if (heading) {
    var link = heading.querySelector('a');
    if (link) return link.textContent.trim();
    return heading.textContent.trim();
  }
  // Fallback: any link to a product
  var link = card.querySelector('a[href*="/products/"]');
  if (link) return link.textContent.trim() || link.getAttribute('aria-label') || '';
  return '';
}

// Check if product is a solar panel
function isSolarPanel(title, handle) {
  var text = ((title || '') + ' ' + (handle || '')).toLowerCase();
  return text.indexOf('solar panel') >= 0 || 
         text.indexOf('solar-panel') >= 0 ||
         (text.indexOf('solar') >= 0 && (text.indexOf('watt') >= 0 || /\d{2,4}w/.test(text))) ||
         text.indexOf('photovoltaic') >= 0 ||
         text.indexOf('pv module') >= 0;
}

// Check if product is sold by pallet
function extractPalletCount(text) {
  if (!text) return null;
  var m = text.match(/pallet\s*(?:of\s*)?(\d+)/i);
  if (m) return parseInt(m[1], 10);
  m = text.match(/(\d+)\s*panel\s*pallet/i);
  if (m) return parseInt(m[1], 10);
  m = text.match(/pallet\s*(?:of\s*)?(\d+)/i);
  if (m) return parseInt(m[1], 10);
  return null;
}

// Format money
function money(val) {
  if (val >= 1000) return '$' + val.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
  return '$' + val.toFixed(2);
}

// Badge icons
function iconCheck() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"/></svg>'; }
function iconShield() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L3 7v6c0 5 3.5 9.5 9 11 5.5-1.5 9-6 9-11V7l-9-5z"/></svg>'; }
function iconWarn() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>'; }

// Enhance a single product card
function enhanceCard(card) {
  // Skip if already enhanced
  if (card.querySelector('.pes-badge-row, .pes-card-wpd')) return;
  
  var title = getCardTitle(card);
  var handle = getCardHandle(card);
  var price = extractPrice(card);
  var wattage = extractWattage(title);
  var isPanel = isSolarPanel(title, handle);
  var palletCount = extractPalletCount(title);
  
  var badges = [];
  
  // $/W display for solar panels
  if (isPanel && wattage && price && price > 0 && wattage > 0) {
    var wpd = price / wattage;
    
    // Best Value badge - only show if this card has the lowest $/W on the page
    // (tracked globally, only top 3 get the badge)
    if (wpd > 0 && !window._pesWpdRanking) window._pesWpdRanking = [];
    if (wpd > 0) {
      window._pesWpdRanking.push({card: card, wpd: wpd});
      // Will be resolved after all cards are scanned
    }
    
    // Add $/W display below the card
    var wpdEl = document.createElement('span');
    wpdEl.className = 'pes-card-wpd';
    wpdEl.innerHTML = '<span class="wpd-label">$\/W: </span>' + money(wpd) + '/W';
    
    // Insert after price or at bottom of card info
    var priceContainer = card.querySelector('.card-information, .card__info, .card__content, .price, .card__heading');
    if (priceContainer) {
      // Find the deepest suitable insertion point
      var insertAfter = card.querySelector('.price, .card__heading, .card-information__text');
      if (insertAfter && insertAfter.parentNode) {
        insertAfter.parentNode.insertBefore(wpdEl, insertAfter.nextSibling);
      } else {
        priceContainer.appendChild(wpdEl);
      }
    }
    
    // Pallet pricing
    if (palletCount && palletCount > 1) {
      var perPanel = price / palletCount;
      var palletEl = document.createElement('span');
      palletEl.className = 'pes-card-pallet';
      palletEl.innerHTML = 'Pallet of ' + palletCount + ': <strong>' + money(perPanel) + '</strong>/panel';
      if (wpdEl.parentNode) {
        wpdEl.parentNode.insertBefore(palletEl, wpdEl.nextSibling);
      }
    }
  }
  
  // Add badge row
  if (badges.length > 0) {
    var badgeRow = document.createElement('div');
    badgeRow.className = 'pes-badge-row';
    badgeRow.innerHTML = badges.join('');
    var heading = card.querySelector('.card__heading, .card-information, .card__content');
    if (heading) {
      heading.insertBefore(badgeRow, heading.firstChild);
    }
  }
}

// Product page enhancements
function enhanceProductPage() {
  var m = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
  if (!m) return;
  
  var handle = m[1];
  
  // Price Match Guarantee badge
  try {
    if (!document.querySelector('.pes-price-match-badge')) {
      var anchor = document.querySelector('.price, .product__info-wrapper .product-form, .product-form, [data-price], .product__info-wrapper, .shopify-payment-button, .product-form__buttons, .product__title, h1, .product-single__meta, .product__meta');
      if (anchor) {
        var badge = document.createElement('div');
        badge.className = 'pes-price-match-badge';
        badge.innerHTML = iconCheck() + '<span><strong>Price Match Guarantee</strong> — Found it cheaper elsewhere? Send us a verified quote and we\'ll meet or beat it. <a href="/pages/quote">Request a price match</a></span>';
        var container = anchor.parentNode || document.body;
        container.insertBefore(badge, anchor.nextSibling);
      }
    }
  } catch(e1) { console.warn('PES price match badge error:', e1.message); }
  
  // EOL banner
  try {
    var eolMeta = document.querySelector('[data-eol-replacement-url]');
    if (eolMeta && !document.querySelector('.pes-eol-banner')) {
      var replacementUrl = eolMeta.getAttribute('data-eol-replacement-url');
      var replacementTitle = eolMeta.getAttribute('data-eol-replacement-title') || 'the recommended replacement';
      var titleAnchor = document.querySelector('h1, .product__title, .product-form, .product-single__meta, .product__info-wrapper');
      if (titleAnchor && titleAnchor.parentNode) {
        var banner = document.createElement('div');
        banner.className = 'pes-eol-banner';
        banner.innerHTML = iconWarn() + '<span>This product has been discontinued. We recommend <a href="' + replacementUrl + '">' + replacementTitle + '</a> as a direct replacement.</span>';
        titleAnchor.parentNode.insertBefore(banner, titleAnchor.nextSibling);
      } else {
        // Fallback: insert at top of body
        var banner2 = document.createElement('div');
        banner2.className = 'pes-eol-banner';
        banner2.innerHTML = iconWarn() + '<span>This product has been discontinued. We recommend <a href="' + replacementUrl + '">' + replacementTitle + '</a> as a direct replacement.</span>';
        var main = document.querySelector('main, #MainContent, .main-content') || document.body;
        main.insertBefore(banner2, main.firstChild);
      }
    }
  } catch(e2) { console.warn('PES EOL banner error:', e2.message); }
  
  // Product page $/W and pallet pricing
  try {
    var titleEl = document.querySelector('.product__title h1, h1.product-title, .product__title, h1');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var wattage = extractWattage(title);
    var palletCount = extractPalletCount(title);
    
    var priceEl = document.querySelector('.price-item--regular, .price__regular .price-item, [data-price], .price-item');
    var price = null;
    if (priceEl) {
      var priceText = priceEl.textContent || '';
      var pm = priceText.match(/\$?([\d,]+\.?\d*)/);
      if (pm) price = parseFloat(pm[1].replace(/,/g, ''));
    }
    
    // Only show price breakdown on solar panel products
      var productTitle = (document.querySelector('h1, .product__title') || {}).textContent || '';
      var productType = (document.querySelector('[data-product-type], .product-type')) || {};
      productType = productType.textContent || '';
      var isPanelProduct = /panel|solar|pv|watt|w/i.test(productTitle) || /solar/i.test(productType);
      if (isPanelProduct && wattage && price && price > 0) {
      var wpd = price / wattage;
      if (!document.querySelector('.pes-pallet-block')) {
        var block = document.createElement('div');
        block.className = 'pes-pallet-block';
        var lines = '<div class="ppb-title">Price Breakdown</div>';
        lines += '<div class="ppb-line"><span>Panel wattage</span><strong>' + wattage + 'W</strong></div>';
        lines += '<div class="ppb-line"><span>Price per watt</span><strong>' + money(wpd) + '/W</strong></div>';
        if (palletCount && palletCount > 1) {
          var perPanel = price / palletCount;
          lines += '<div class="ppb-line"><span>Pallet total (' + palletCount + ' panels)</span><strong>' + money(price) + '</strong></div>';
          lines += '<div class="ppb-line"><span>Price per panel</span><strong>' + money(perPanel) + '</strong></div>';
        }
        block.innerHTML = lines;
        var formAnchor = document.querySelector('.product-form, .product__info-wrapper, .product-single__meta, .product__price, .price__container');
        if (formAnchor) {
          formAnchor.appendChild(block);
        }
      }
    }
  } catch(e3) { console.warn('PES pallet block error:', e3.message); }
}

// Scan all cards on the page
function scanCards(root) {
  var scope = root || document;
  var cards = scope.querySelectorAll('.card-wrapper, .product-card-wrapper, [data-product-url]');
  cards.forEach(function(card) {
    try {
      enhanceCard(card);
    } catch(e) {
      // Silently skip failed cards
    }
  });
  
  // Resolve Best Value badges - only top 3 lowest $/W get the badge
  if (window._pesWpdRanking && window._pesWpdRanking.length > 0) {
    window._pesWpdRanking.sort(function(a, b) { return a.wpd - b.wpd; });
    var top3 = window._pesWpdRanking.slice(0, Math.min(3, window._pesWpdRanking.length));
    top3.forEach(function(item) {
      var badgeEl = document.createElement('span');
      badgeEl.className = 'pes-badge pes-badge--best-value';
      badgeEl.innerHTML = iconShield() + ' Best Value';
      var heading = item.card.querySelector('.card__heading, .card-information, .card__content, .pes-badge-row');
      if (heading) {
        var badgeRow = heading.querySelector('.pes-badge-row') || heading;
        if (badgeRow.classList && badgeRow.classList.contains('pes-badge-row')) {
          badgeRow.appendChild(badgeEl);
        } else {
          var row = document.createElement('div');
          row.className = 'pes-badge-row';
          row.appendChild(badgeEl);
          heading.insertBefore(row, heading.firstChild);
        }
      }
    });
    window._pesWpdRanking = [];
  }
}

// Check if current page is a product page
function isProductPage() {
  return window.location.pathname.indexOf('/products/') >= 0;
}

// Init
function init() {
  injectStyles();
  scanCards(document);
  if (isProductPage()) enhanceProductPage();
  
  // Re-scan when DOM changes (for infinite scroll, AJAX pagination)
  var debounce = null;
  var mo = new MutationObserver(function() {
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(function() {
      scanCards(document);
      if (isProductPage()) enhanceProductPage();
    }, 300);
  });
  mo.observe(document.body, {childList: true, subtree: true});
  
  // Re-scan on URL change (for Shopify navigation)
  window.addEventListener('popstate', function() {
    setTimeout(function() {
      scanCards(document);
      if (isProductPage()) enhanceProductPage();
    }, 500);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { try { init(); } catch(e) { console.warn('PES init error:', e.message); } });
} else {
  try { init(); } catch(e) { console.warn('PES init error:', e.message); }
}

// Expose for debugging — set BEFORE init to guarantee it's always true
window.pesCompetitiveFeaturesV6 = true;

document.addEventListener('shopify:section:load', function() {
  try { scanCards(document); if (isProductPage()) enhanceProductPage(); } catch(e) {}
});

})();

// v6.1 cache-bust 1785758924